/**
 * TODO - FHL Refactor
 * - během vývoje vznikalo tolik nových situací, že kód může být místy nelogický a nepřehledný (nicméně funguje správně)
 * - cílem bude zjednodušení a zpřehlednění kódu
 *
 * TODO - FHL JSDoc
 */
/**

 <input id="count" name="count" type="text" class="js_dhtml-number" value="1" data-min="1" data-max="5" data-step="1">
 <script>
 $('.js_dhtml-number').dhtmlNumber();
 </script>

 **/

var $ = require('jquery');
'use strict';

var PLUGIN_NAME = 'dhtmlNumber';

var	DEFAULTS = {
	minValue				    :	null,
	maxValue				    :	null,
	defaultValue		    :	1,
	step					      :	1,
	wrapperAdd				  :	true,
	wrapperClass			  :	'',
	disabledStateClass      : 'disabled',
	autofixTimeoutFloat :	1000,
	autofixTimeoutInteger :500,
	changeTimeout			  :	500,
	changeEvent				  :	'DHTML_NUMBER_CHANGE_PERFORMED',
	decreaseEvent				  : 'DHTML_NUMBER_DECREASE_PERFORMED',
	increaseEvent				  : 'DHTML_NUMBER_INCREASE_PERFORMED',
	showCustomMessages	:	true,
	messagesClassName		: 	'help-block',
	lang					      :	'cs',
	messages				    :	{
		'cs': {
			MIN_REACHED		    :	'Nelze zvolit menší počet než {{num}}',
			MAX_REACHED		    :	'Nelze zvolit vyšší počet než {{num}}',
			AMOUNT_FIXED	    :	'Vámi zvolený počet byl upraven tak, aby odpovídal množství v balení'
		},
		'en': {
			MIN_REACHED		    :	'You cannot select less than {{num}} items',
			MAX_REACHED		    :	'You cannot exceed {{num}} items',
			AMOUNT_FIXED	    :	'Provided amount has been fixed to match the package'
		}
	}
};

/**
 * constructor
 * @param selector
 * @param options
 * @constructor
 */
var DhtmlNumber = function (selector, options) {
	this.$t = $(selector);
	this.$wrapper = null;

	this.options = $.extend(true, {}, DEFAULTS, options );
	this._defaults = DEFAULTS;

	this.initialise_();
};

/**
 * init funkce, nastavení potřebných proměnných a spuštění render a obslužných funkcí
 * @private
 */
DhtmlNumber.prototype.initialise_ = function() {
	// vypnutí našeptávače
	this.$t.attr('autocomplete', 'off');

	// force input[type=text], number nechceme kvůli možnosti zapisování desetinné čárky
	this.$t.attr('type', 'text');

	this.changeTimeout = null;

	// obalit spanem, kvůli případnému stylování šipek
	this.$wrapper = this.createWrapper_();

	// nastavení proměnných z data atributů
	this.minValue 		  =  parseFloat(this.$t.data('min') || this.options.minValue) || 0;
	this.maxValue 		  =  parseFloat(this.$t.data('max') || this.options.maxValue);
	this.defaultValue 	=  parseFloat(String((this.$t.val() || this.$t.data('default')) || this.options.defaultValue).replace(',', '.'));
	this.stepRaw		    =  this.$t.data('step') || this.options.step;		// použito pro formátování desetinných míst přesně dle stepu (zachování stringu)
	this.step 			    =  parseFloat(this.stepRaw);
	this.decimals 		  =  this.getNumberOfDecimals_();

	this.maxReached		  = false;
	this.minReached 	  = false;
	this.valueFixed		  = false;

	this.messages 		  = this.options.messages[this.options.lang];
	this.$message 		  = null;
	this.showMessages 	  = this.options.showCustomMessages || this.minValue != this.maxValue;	// pokud je min a max stejný, vypneme message

	this.increase		  = true;
	this.lastValue		  = this.defaultValue;
	this.currentDiff	  = 0;

	// set initial value
	this.$t.val(this.applyLocalizedFormatting_(this.defaultValue));
	this.actualValue = this.defaultValue;

	// render controls and handles them
	this.renderControls_();
	this.bindEvents_();
};

/**
 * vytvoří wrapper kolem inputu, aby bylo možné jednoduše nastylovat spinner
 * @returns {*}
 * @private
 */
DhtmlNumber.prototype.createWrapper_ = function() {
	var $wrapper = null;

	if(!this.options.wrapperAdd) return null;

	this.$t.wrap('<span></span>');
	$wrapper = this.$t.parents('span');
	$wrapper.addClass(this.options.wrapperClass);

	return $wrapper;
};

/**
 * renders controls for increasing and decreasing value
 * @private
 */
DhtmlNumber.prototype.renderControls_ = function() {
	var $controlsWrapper = $('<span class="dhtml-number-controls-group"></span>').appendTo(this.$wrapper);
	this.$decrease = $('<a href="javascript:void(0)" class="decrease" title="−">−</a>').appendTo($controlsWrapper);
	this.$increase = $('<a href="javascript:void(0)" class="increase" title="+">+</a>').appendTo($controlsWrapper);
	this.updateButtonsState_();
};

DhtmlNumber.prototype.bindEvents_ = function() {
	var self_ = this;

	// click plus
	this.$increase.on('click', function(e) {

		if (self_.maxReached) {
			self_.renderMessage_('max');
			return false;
		}

		var val = parseFloat(self_.$t.val().replace(',', '.'));
		if(isNaN(val)) {
			val = self_.step;
		}
		val += self_.step;
		val = self_.roundByDecimals_(val);
		val = self_.checkFitInStep_(val);
		val = self_.checkValidity_('max', self_.maxValue, val, false);

		self_.storeValue_(val);
	});

	// click minus
	this.$decrease.on('click', function(e) {

		if (self_.minReached) {
			self_.renderMessage_('min');
			return false;
		}

		var val = parseFloat(self_.$t.val().replace(',', '.'));
		if(isNaN(val)) {
			val = self_.step;
		}
		val -= self_.step;
		val = self_.roundByDecimals_(val);
		val = self_.checkFitInStep_(val);
		val = self_.checkValidity_('min', self_.minValue, val, false);

		self_.storeValue_(val);
	});

	this.$t.on('keypress', function(e){
	  // integer
	  if (Number.isInteger(self_.step)) {
      self_.handleKeypress_(/^[0-9]+$/, e);
    }
    // float
    else {
      self_.handleKeypress_(/^[0-9]|[\,]|[\.]+$/, e);
    }
  });

	// do validity checks and store new value
	this.$t.on('keyup', function(e) {
	  let autofixTimeout = self_.options.autofixTimeoutInteger;

    if (!Number.isInteger(self_.step)) {
      autofixTimeout = self_.options.autofixTimeoutFloat;
    }

		self_.removeMessage_();

		clearTimeout(self_.changeTimeout);

    self_.changeTimeout = window.setTimeout(function () {
      self_.evaluateKeyPressed_($(e.currentTarget));
    }, autofixTimeout)
	});
};

DhtmlNumber.prototype.handleKeypress_ = function(pattern, e) {
  var self_ = this;

  var result = pattern.test(String.fromCharCode(e.which));

  if ((($.inArray(e.keyCode, [9, 27, 13, 46, 110, 190]) !== -1) && (e.which == 0))  ||
    (e.keyCode == 8) ||
    (e.keyCode == 13) ||
    // Allow: Ctrl+A
    (e.keyCode == 65 && e.ctrlKey === true) ||
    // Allow: Ctrl+C
    (e.keyCode == 67 && e.ctrlKey === true) ||
    // Allow: Ctrl+X
    (e.keyCode == 88 && e.ctrlKey === true) ||
    // Allow: home, end, left, right
    (e.keyCode >= 35 && e.keyCode <= 39)) {
    // let it happen, don't do anything
    return;
  }

  if (result) {
    return result;
  }
  else {
    e.preventDefault();
  }
};

DhtmlNumber.prototype.updateButtonsState_ = function() {
	var self = this;

	if (self.actualValue == self.minValue || self.$t.is(':disabled')) {
		self.$decrease.addClass(self.options.disabledStateClass);
	}
	else {
		self.$decrease.removeClass(self.options.disabledStateClass);
	}

	if (self.actualValue == self.maxValue || self.$t.is(':disabled')) {
		self.$increase.addClass(self.options.disabledStateClass);
	}
	else {
		self.$increase.removeClass(self.options.disabledStateClass);
	}
};

DhtmlNumber.prototype.evaluateKeyPressed_ = function($input) {

	var val = $input.val();
	val = parseFloat(val.replace(',', '.'));

	if (val != '-' && isNaN(val)) {
		$input.val(this.applyLocalizedFormatting_(this.actualValue));
	} else {

		if (val != '-') {

			val = this.checkValidity_('min', this.minValue, val, true);	// kontrola na minimum
			val = this.checkValidity_('max', this.maxValue, val, true);	// kontrola na maximum
			val = this.checkFitInStep_(val, true);						// kontrola na to, zda odpovídá hodnota stepu
		}

		this.storeValue_(val);
	}
};

/**
 *
 *
 */
DhtmlNumber.prototype.checkValidity_ = function(type, threshold, value, disableThresholdFlag) {
	var result, stepDiff;
	var step = this.step;

	if (type === 'max') {

		if (threshold !== null && value > threshold) {
			stepDiff = parseFloat(this.roundByDecimals_(threshold % step));

			// TODO FHL - vyřešit zápornou minValue - způsobeno nekonzistentním požadavkem, kdy minValue nemusí být nutně násobkem stepu
			if (this.minValue >= 0) {
				result = threshold - stepDiff + this.minValue;
				result = result > this.maxValue ? result - step : result;
			} else {
				result = this.maxValue;
			}

		} else {
			result = value;
		}

		if (result + step > threshold && !disableThresholdFlag) {
			this.maxReached = true;
		}
	}

	if (type === 'min') {
		if (threshold !== null && value < threshold) {
			result = threshold;
		} else {
			result = value;
		}

		if (result - step < threshold && !disableThresholdFlag) {
			this.minReached = true;
		}
	}

	return result;
};

/**
 * kontrola, zda value je násobkem stepu, pokud ne, je vybrána nejbližší vyšší hodnota (pokud není vyšší, než maximum)
 *
 */
DhtmlNumber.prototype.checkFitInStep_ = function(value, setChangeFlag) {

	this.removeMessage_();
	this.minReached = false;
	this.maxReached = false;

	value = parseFloat(value);

	var result = value;
	var diff = (value - this.minValue) % this.step;
	diff = diff.toFixed(this.decimals);	// oříznutí na tolik desetinných míst, kolik má step. Vyřešení problému, kdy JS počítá např. 5.2 + 2.6 = 7.800000...0001

	if (diff > 0 && diff != this.step) {
		result = value + this.step - diff;
		result = result > this.maxValue ? result - this.step : result;
		if (setChangeFlag) {
			this.valueFixed = true;
		}
	}

	if (result == this.minValue) {
		this.minReached = true;
	}

	if (result + this.step > this.maxValue) {
		this.maxReached = true;
	}

	return result;
};

DhtmlNumber.prototype.applyLocalizedFormatting_ = function(num) {
 return String(this.roundByDecimals_(num)).replace(',', '.')
};

/**
 * extrahuje počet desetinných míst dle stepu
 *
 */
DhtmlNumber.prototype.getNumberOfDecimals_ = function() {
	var s = String(this.stepRaw);
	var len= 0;
	if (s.indexOf(".") > -1) {
		len = s.substring(s.indexOf(".")+1, s.length).length;
	}

	return len;
};

/**
 * zaokrouhlení čísla na tolik desetinných míst, na kolik byl definován původní step
 * @private
 */
DhtmlNumber.prototype.roundByDecimals_ = function(num) {
	return Number(num).toFixed(this.decimals);
};

/**
 * trigger change
 * @private
 */
DhtmlNumber.prototype.performChange_ = function() {
	var self_  = this;
	clearTimeout(this.changeTimeout);
	this.changeTimeout = setTimeout(function() {
		self_.$t.trigger(self_.options.changeEvent, [{
			input: self_.$t,
			instance: self_
		}]);
		if ((self_.increase) && (self_.currentDiff != 0)) {
			self_.$t.parents('.dhtml-number').trigger(self_.options.increaseEvent, [{
				input: self_.$t,
				diff: self_.currentDiff,
				instance: self_
			}]);
		}
		else if ((!self_.increase) && (self_.currentDiff != 0)) {
			self_.$t.parents('.dhtml-number').trigger(self_.options.decreaseEvent, [{
				input: self_.$t,
				diff: self_.currentDiff,
				instance: self_
			}]);
		}
	}, this.options.changeTimeout);
};

/**
 *
 *
 **/
DhtmlNumber.prototype.storeValue_ = function(value) {
	this.$t.val(this.applyLocalizedFormatting_(value));
	this.actualValue = value;

	if (this.actualValue > this.lastValue) {
		this.increase = true;
		this.currentDiff = this.actualValue - this.lastValue;
	}
	else if (this.actualValue < this.lastValue) {
		this.increase = false;
		this.currentDiff = this.lastValue - this.actualValue;
	}
	else {
		this.currentDiff = 0;
	}

	this.lastValue = this.actualValue;

	if (this.valueFixed) {
		this.renderMessage_('fix');
		this.valueFixed = false;
	}

	this.performChange_();
	this.updateButtonsState_();
};

/**
 *
 *
 **/
DhtmlNumber.prototype.renderMessage_ = function(type) {
	this.removeMessage_();
	this.$message = $('<span class="' + this.options.messagesClassName + '"></span>');

	if (type === 'max') {
		this.$message.text(this.applyMessage_(this.messages.MAX_REACHED, {
			num: this.maxValue
		}));
	}

	if (type === 'min') {
		this.$message.text(this.applyMessage_(this.messages.MIN_REACHED, {
			num: this.minValue
		}));
	}

	if (type === 'fix') {
		this.$message.text(this.messages.AMOUNT_FIXED);
	}

	this.$wrapper.after(this.$message);
};

/**
 *
 * @private
 */
DhtmlNumber.prototype.removeMessage_ = function() {
	if (this.$message instanceof $) {
		this.$message.off().remove();
		this.$message = null;
	}
};

/**
 * vloží do message hodnoty na správná místa - hodnoty jsou zadávány v objektu values (key - value)
 * @private
 */
DhtmlNumber.prototype.applyMessage_ = function(message, values) {
	var regexp;
	for (var key in values) {
		if (values.hasOwnProperty(key)) {
			regexp = new RegExp('{{' + key + '}}', 'g');
			message = message.replace(regexp, values[key]);
		}
	}
	return message;
};

/**
 * decide, which methods will be "public"
 */
var API = {};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 * 		if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function (value) {
	var args = arguments;

	return this.each(function () {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new DhtmlNumber(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.dhtmlnumber.js